import { DESTINATION_TYPES } from 'screens/YieldV2/Loads/constants';
import { tabsLabels } from './constants';

const validateDestination = (_tabs, destinationType) => {
  if (destinationType === DESTINATION_TYPES.STORAGE) {
    const cloneTabs = { ..._tabs };
    delete cloneTabs[tabsLabels.saleInfo];
    return cloneTabs;
  }
  return _tabs;
};

export default validateDestination;
